import getCenterCoordinates from './getCenterCoordinates'

const getMarkerCoordinates = (coordinatesMatrixes) => {
  try {
    let coordinatesMatrix = coordinatesMatrixes[0]

    if (coordinatesMatrixes.length > 2) {
      coordinatesMatrix = coordinatesMatrixes[Math.floor(coordinatesMatrixes.length / 2)]
    }

    let coordinates = coordinatesMatrix[0]

    if (typeof coordinates[0] === 'number') {
      coordinates = coordinatesMatrix
    } else if (coordinatesMatrix.length > 2) {
      coordinates = coordinatesMatrix[Math.floor(coordinatesMatrix.length / 2)]
    }

    return getCenterCoordinates(coordinates)
  } catch (e) {
    console.log(e)

    try {
      return coordinatesMatrixes[0][0][0]
    } catch (e) {
      console.log(e)
      return []
    }
  }
}

export default getMarkerCoordinates
